import { useEffect, useState } from "react";
import { useFETCH, usePOST } from "../../APIs/useMyAPI";
import { Col, Row } from "../../Grid-system";
import { useParams } from "react-router-dom";
import Loading from "../../Tools/Loading";
import { Back, ButtonRed } from "../../components";
const FileInput = ({ name, value, setFormData, formData, title }) => {
  const [preview, setPreview] = useState("");

  useEffect(() => {
    if (!value) {
      setPreview("");
    } else if (typeof value === "string") {
      // Only set preview if value is URL
      setPreview(value);
    }
    // if value is File, keep existing preview
  }, [value]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFormData({ ...formData, [name]: file });
    setPreview(URL.createObjectURL(file));
  };

  const handleDelete = () => {
    setFormData({ ...formData, [name]: "" });
    setPreview("");
  };

  return (
    <div className="mb-4">
      <label className="block mb-1 font-medium">{title}</label>

      {preview && (
        <div className="mb-2">
          <img
            src={preview}
            alt="preview"
            className="w-40 h-40 object-contain border rounded"
          />
        </div>
      )}

      <input type="file" accept="image/*" onChange={handleFileChange} />

      {preview && (
        <button
          type="button"
          onClick={handleDelete}
          className="mt-2 px-3 py-1 bg-red-500 text-white rounded"
        >
          Delete
        </button>
      )}
    </div>
  );
};

const EditWebsiteInfo = () => {
  const { id } = useParams();
  const { formData, setFormData, handleSubmit, loading, error } = usePOST({});

  // Fetch existing website info
  const { data, fetchData } = useFETCH(`admin/users/${id}/website-info`);

  useEffect(() => {
    if (data?.data) {
      setFormData(data.data?.data);
    }
  }, [data]);

  const handleSubmitMain = (e) => {
    e.preventDefault();

    const submitData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key] instanceof File) {
        submitData.append(key, formData[key]);
      } else {
        submitData.append(key, formData[key] || "");
      }
    });

    handleSubmit(`admin/users/${id}/website-info/update`, submitData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  return (
    <div>
      <Row justify="center">
        <Col md={7}>
          <h2 className="text-xl font-bold mb-4">Edit Website Info</h2>

          <div className="mb-4">
            <label className="block mb-1 font-medium">Website Name</label>
            <input
              type="text"
              name="website_name"
              value={formData?.website_name || ""}
              onChange={(e) =>
                setFormData({ ...formData, website_name: e.target.value })
              }
              className="border p-2 rounded w-full"
              placeholder="e.g. My Website"
            />
          </div>

          <div className="mb-4">
            <label className="block mb-1 font-medium">Website URL</label>
            <input
              type="text"
              name="website_url"
              value={formData?.website_url || ""}
              onChange={(e) =>
                setFormData({ ...formData, website_url: e.target.value })
              }
              className="border p-2 rounded w-full"
              placeholder="e.g. https://example.com"
            />
          </div>

          <FileInput
            name="logo_url"
            value={formData?.logo_url}
            setFormData={setFormData}
            formData={formData}
            title="Logo"
          />

          <div className="mt-4">
            <label className="block mb-1 font-medium">Logo Width</label>
            <input
              type="text"
              name="logo_width"
              value={formData?.logo_width || ""}
              onChange={(e) =>
                setFormData({ ...formData, logo_width: e.target.value })
              }
              className="border p-2 rounded w-full"
              placeholder="e.g. 150px"
            />
          </div>

          <div className="mt-4">
            <label className="block mb-1 font-medium">Logo Mobile Width</label>
            <input
              type="text"
              name="logo_mobile_width"
              value={formData?.logo_mobile_width || ""}
              onChange={(e) =>
                  setFormData({ ...formData, logo_mobile_width: e.target.value })
                }
                className="border p-2 rounded w-full"
                placeholder="e.g. 150px"
              />
            </div>
          <div className="mt-4">
            <FileInput
              name="icon_url"
              value={formData?.icon_url}
              setFormData={setFormData}
              formData={formData}
              title="Icon"
            />
          </div>

          <div className="mt-4">
            <label className="block mb-1 font-medium">Primary Color</label>
            <input
              type="color"
              name="primary_color"
              value={formData?.primary_color || "#000000"}
              onChange={(e) =>
                setFormData({ ...formData, primary_color: e.target.value })
              }
              className="w-16 h-10 ml-2"
            />
          </div>

          <div className="mt-4">
            <label className="block mb-1 font-medium">Secondary Color</label>
            <input
              type="color"
              name="secondary_color"
              value={formData?.secondary_color || "#ffffff"}
              onChange={(e) =>
                setFormData({ ...formData, secondary_color: e.target.value })
              }
              className="w-16 h-10 ml-2"
            />
          </div>

          <FileInput
            name="body_bg_image"
            value={formData?.body_bg_image}
            setFormData={setFormData}
            formData={formData}
            title="Body Background Image"
          />

          <FileInput
            name="footer_bg_image"
            value={formData?.footer_bg_image}
            setFormData={setFormData}
            formData={formData}
            title="Footer Background Image"
          />

          {loading && <Loading />}
          <div className="text-red-500 font-semibold">{error}</div>

          <ButtonRed
            name="Save Changes"
            className="px-4 py-3 mt-4"
            onClick={handleSubmitMain}
          />
        </Col>
      </Row>
      <Back />
    </div>
  );
};

export default EditWebsiteInfo;
